import { createSelector } from "reselect";
import { dataSelector } from "src/selectors/data_selectors/data_selector";

/**
 * Selector for the tallies object in the data tree in the store
 */
export const populationTalliesSelector = createSelector(
  dataSelector,
  data => data.populationTalliesByEtiology
);
